/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Wise_Marten_YellInputs */

const en_safe_wise_marten_yell = /** @type {(inputs: Safe_Wise_Marten_YellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Change organization`)
};

const de_safe_wise_marten_yell = /** @type {(inputs: Safe_Wise_Marten_YellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Organisation wechseln`)
};

/**
* | output |
* | --- |
* | "Change organization" |
*
* @param {Safe_Wise_Marten_YellInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_wise_marten_yell = /** @type {((inputs?: Safe_Wise_Marten_YellInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Wise_Marten_YellInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_wise_marten_yell(inputs)
	return de_safe_wise_marten_yell(inputs)
});